export function formatDateFr(input?: string | Date | null): string {
  if (!input) return '';
  // Supporte ISO "YYYY-MM-DD" ou "YYYY-MM-DDTHH:mm:ssZ"
  if (typeof input === 'string') {
    const m = input.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) {
      const [, y, mo, d] = m;
      return `${d}/${mo}/${y}`;
    }
    // Fallback: tentative parse standard
    const d2 = new Date(input);
    if (!isNaN(d2.getTime())) {
      return d2.toLocaleDateString('fr-FR');
    }
    return '';
  }
  const d = input instanceof Date ? input : new Date(input as any);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('fr-FR');
}
